<template>
  <div class="import_dialog">
    <drag-dialog
      :visible.sync="visible"
      :title="'上传报告模版'"
      width="700px"
      height="500px"
      :before-close="() => $emit('update:visible', false)"
      @close="$dialogFormReset()"
    >
      <el-form label-width="120px">
        <el-row :gutter="20" type="flex" style="flex-wrap: wrap">
          <el-col :span="24">
            <el-form-item label="检测项目">
              <el-input disabled :value="activeInfo.remark" placeholder="请输入委托单编号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="模版编号">
              <el-input disabled :value="activeInfo.sampleCode" placeholder="请输入委托单编号" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <section class="import_box">
        <div class="content">
          <el-upload
            class="upload-demo"
            drag
            ref="upload"
            :on-change="fileChange"
            :auto-upload="false"
            :action="''"
            accept=".docx"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或
              <em>点击上传</em>
            </div>
            <div class="el-upload__tip" slot="tip">仅允许导入“docx”格式文件！</div>
          </el-upload>
        </div>
      </section>
      <template slot="footer">
        <el-button type="primary" @click="importFile">导 入</el-button>
      </template>
    </drag-dialog>
  </div>
</template>

<script>
import { getToken } from '@/utils/auth';
import { uploadReportWordTemplate } from '@/api/system';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    // 模板地址
    downLoadUrl: {
      type: String,
      default: ''
    },
    activeInfo: {
      type: Object,
      default: () => ({})
    }
  },
  name: 'ImportDialog',
  data() {
    return {
      editForm: {},
      fileList: [],
      VUE_APP_BASE_API: process.env.VUE_APP_BASE_API
    };
  },
  watch: {
    visible(value) {
      if (!value) {
        this.$refs.upload.clearFiles();
      }
    }
  },
  methods: {
    async importFile() {
      if (this.fileList.length > 0) {
        let formData = new FormData();
        let file = this.fileList[0].raw;
        formData.append('file', file);
        formData.append('token', getToken());
        formData.append('modelCode', this.activeInfo.sampleCode);

        try {
          await uploadReportWordTemplate(formData);

          this.$emit('refreshData');
          this.$message.success('上传成功！');
          this.$emit('update:visible', false);
        } finally {
          this.importLoading = false;
        }
      } else {
        this.$message({
          message: '请先选择文件',
          type: 'warning'
        });
      }
    },
    fileChange(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
      this.fileList = fileList;
    }
  }
};
</script>

<style lang="scss">
.import_dialog {
  .import_box {
    display: flex;
    justify-content: center;
    padding-top: 16px;
    width: 100%;
    height: 100%;

    ::v-deep .upload-demo {
      width: 500px !important;
    }

    ::v-deep .el-upload-dragger {
      width: 500px !important;
    }

    ::v-deep .el-upload-dragger {
      margin: 0 auto;
    }
  }

  .model {
    margin-right: 30px;
    font-size: 14px;
    color: #64bfc1;
    cursor: pointer;
  }
}
</style>
